import React from "react";
import Box from "@mui/material/Box";
import FormControlLabel from "@mui/material/FormControlLabel";
import Grid from "@mui/material/Grid";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";

import SVG from "@/assets/svg";
import CostumeButton from "@/component/button";
import { ScheduleVisit, Visit } from "@/interfaces/IServiceUser";
import {
  getRRule,
  getRRuleAsObject,
  RRuleFrequencies,
  rruleWeekDays,
} from "@/utils/helpers";
import logger from "@/runtime-utils/observability/logger";
import { getScheduleVisitTrace } from "@/utils/scheduleVisitTrace";
import VisitLayout from "../visit-info/visit";

interface IDeleteVisit {
  loading: boolean;
  onClose: () => void;
  handleConfirm: (val: boolean) => void;
  visit: Visit | null;
}

function DeleteVisit({ loading, onClose, handleConfirm, visit }: IDeleteVisit) {
  const [changeAll, setChangeAll] = React.useState("false");

  const isOriginal = !visit?.origin;

  return (
    <>
      <div>
        <VisitLayout>
          <Box className="Add-medication">
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: "19px",
              }}
            >
              <Typography id="modal-modal-title" variant="h3">
                Delete Visit
                {visit && (
                  <span
                    className="dayData"
                    style={{
                      margin: "3px 0",
                    }}
                  >
                    Repeats{" "}
                    {(() => {
                      try {
                        const rule = getRRule(visit);
                        const rrule = rule.rrules()[0];
                        return rrule ? rrule.toText() : "Custom";
                      } catch (err) {
                        logger.error(
                          getScheduleVisitTrace(visit, err),
                          "Schedule visit recurrence parsing failed"
                        );
                        return "Custom";
                      }
                    })()}
                  </span>
                )}
              </Typography>
              <Box onClick={onClose}>
                <SVG.Cross />
              </Box>
            </Box>
            <Box>
              <Grid
                className="personal"
                size={{
                  xs: 12,
                  md: 6,
                }}
              >
                <Box className="medicationViewList">
                  <RadioGroup
                    value={changeAll}
                    onChange={(e) => setChangeAll(e.target.value)}
                  >
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label="Including all the future visits in the schedule"
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label="This visit only"
                    />
                  </RadioGroup>
                </Box>
              </Grid>
              <Box
                sx={{ display: "flex", width: "100%", justifyContent: "end" }}
              >
                <CostumeButton onClick={onClose} className="cancel">
                  {" "}
                  Cancel
                </CostumeButton>
                <CostumeButton
                  loading={loading}
                  onClick={() => handleConfirm(changeAll === "true")}
                  className="invite"
                  sx={{ width: " 120px" }}
                >
                  {" "}
                  Save
                </CostumeButton>
              </Box>
            </Box>
          </Box>
        </VisitLayout>
      </div>
    </>
  );
}

export default DeleteVisit;
